import { ResourceOptions } from 'react-admin';
import { FaMoneyBillWave } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingRedpacketLedger;
export const icon = FaMoneyBillWave;
export const options: ResourceOptions = {
  label: 'module.socialTrading.redpacketLedger',
};
